import { useTranslation } from "react-i18next";

const VALUE_ICONS = ["feather-terminal", "feather-gift", "feather-users", "feather-award"];
const VALUE_KEYS = ["learnByBuilding", "freeForever", "realEngineers", "verifiedCertificates"];
const VALUE_DEFAULTS = [
  {
    title: "Learn by building",
    desc: "Every module ends in a real project, not a quiz bank. You leave with things you actually made.",
  },
  {
    title: "100% free, forever",
    desc: "No trial period, no paywalled modules, no upsell halfway through. Every course, every lesson, free.",
  },
  {
    title: "Taught by real engineers",
    desc: "Instructors who've shipped production code and real design work — not narrators reading slides.",
  },
  {
    title: "Certificates that verify",
    desc: "Finish a course and get a certificate anyone can check is real, right on this site.",
  },
];

const ValueProps = () => {
  const { t } = useTranslation("home");

  const values = VALUE_KEYS.map((key, i) => ({
    icon: VALUE_ICONS[i],
    title: t(`valueProps.${key}.title`, VALUE_DEFAULTS[i].title),
    desc: t(`valueProps.${key}.desc`, VALUE_DEFAULTS[i].desc),
  }));

  return (
    <div className="rbt-value-grid">
      {values.map((value) => (
        <div className="rbt-value-card" key={value.title}>
          <span className="rbt-value-card__icon">
            <i className={value.icon}></i>
          </span>
          <h3 className="rbt-value-card__title">{value.title}</h3>
          <p className="rbt-value-card__desc">{value.desc}</p>
        </div>
      ))}
    </div>
  );
};

export default ValueProps;
